import { Injectable } from '@angular/core';

@Injectable()
export class EnderecoModel {

    codigoEndereco: string;
    enderecoCompleto: string;
    codigoMicroarea: string;
    logradouro: string;
    numero: string;
    complemento: string;
    latitude: string;
    longitude: string;
    cep: string;
    bairro: string;
    cidade: string;
    estado: string;
    pais: string;

    constructor() {}
}
